
import { basePath, apiVersion } from "./config";

export async function getPersonaRpp (token, query) {
  const url = `${basePath}/${apiVersion}/rpps${query}`;


  const params = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
  };

  try {
    const response = await fetch(url, params);
    const result = await response.json();

    if (!response.ok) {
      const error = new Error(result.mensaje || "Error en la consulta de personas");
      error.endpoint = url;
      error.backendMessage = result.detalles || JSON.stringify(result);
      throw error;
    }

    return result;

  } catch (err) {
    if (!err.endpoint) {
      err.endpoint = url;
    }
    throw err;
  }
}



export async function  getRppDetalle (token,id) {
  const url = `${basePath}/${apiVersion}/rpp/${id}`;

  const params = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
  };

  try {
    const response = await fetch(url, params);
    const result = await response.json();

    if (!response.ok) {
      const error = new Error(result.mensaje || "Error en la consulta de personas");
      error.endpoint = url;
      error.backendMessage = result.detalles || JSON.stringify(result);
      throw error;
    }

    return result;

  } catch (err) {
    if (!err.endpoint) {
      err.endpoint = url;
    }
    throw err;
  }
}
